import axios from "axios";
import { useState, useEffect, useRef } from "react";
import {
  DASHBOARD,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
} from "../../routes/routes";
import { Link } from "react-router-dom";
import Select from "react-select";
import { NoDataFound, NoUserFound, hasRole } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Glasschap from "../../assets/images/chapter.png";
import Glassusers from "../../assets/images/users.png";
import Contribution from "../../assets/images/contribution.png";
import Region from "../../assets/images/region.png";
import Country from "../../assets/images/region.png";
import State from "../../assets/images/region.png";
import Events from "../../assets/images/events.png";
import One2one from "../../assets/images/one2one.png";
import Referals from "../../assets/images/referals.png";
import Admin from "../../assets/images/admin.png";
import Guest from "../../assets/images/guest.png";
import Powerdate from "../../assets/images/powerdate.png";
import Inductions from "../../assets/images/guest.png";
import Consumers from "../../assets/images/guest.png";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "./DashboardNew.css";
import "flatpickr/dist/themes/material_red.css";
import Loader, { OvalLoader } from "../../components/common/Loader"; // Import the loader component
// import profileImg1 from "../../assets/images/profile1.jpg";
// import One2oneRed from "../../assets/images/onetoone-red.png";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart } from "@mui/x-charts/LineChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import Smile from "../../assets/images/smile.png";
import calendarWhite from "../../assets/images/calendar-white.png";
import OnetoOneWhite from "../../assets/images/onetoone-white.png";
import RflWhite from "../../assets/images/rfl-white.png";
import VisitorsWhite from "../../assets/images/visitors-white.png";
import chiefGuestWhite from "../../assets/images/cheif-guest-white.png";
import user1 from "../../assets/images/user-1.jpg";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import { IoStatsChart as FaChartSimple } from "react-icons/io5";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Navigation } from "swiper/modules";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const Dashboard = () => {
  const { hasPermission } = usePermission();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ovalLoading, setOvalLoading] = useState(true);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState([]);
  const [chapterOptions, setChapterOptions] = useState([]);
  const [filter, setFilter] = useState([]);
  const [showClearBtn, setShowClearBtn] = useState(false);
  const refFlatpickr = useRef(null);
  const [pdfLoading, setPdfLoading] = useState(false);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const filterBarRef = useRef(null);
  const [filterBarHeight, setFilterBarHeight] = useState(80);

  // Add body class so navbar transparency can be overridden only on dashboard
  useEffect(() => {
    document.body.classList.add("dashboard-page");
    return () => {
      document.body.classList.remove("dashboard-page");
    };
  }, []);

  // Dynamically measure filter bar height so spacer always matches
  useEffect(() => {
    const el = filterBarRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      setFilterBarHeight(el.offsetHeight - 22);
    });
    observer.observe(el);
    // Set initial height
    setFilterBarHeight(el.offsetHeight);
    return () => observer.disconnect();
  }, []);

  // Add blur effect to filter bar on scroll
  useEffect(() => {
    const handleScroll = () => {
      const el = filterBarRef.current;
      if (!el) return;
      if (window.scrollY > 10) {
        el.classList.add("filter-bar-scrolled");
      } else {
        el.classList.remove("filter-bar-scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const handleDownloadPDF = async (reportType) => {
    try {
      setPdfLoading(true);
      // Create a new PDF document
      const currentDate = moment().format("DD-MM-YYYY");
      const doc = new jsPDF("landscape");
      var headers = [];
      var pdfData = [];
      var fileName = "";
      var pdfTitle = "";

      headers = ["Sl.No."];
      if (hasRole([1])) {
        headers.push("Country");
      }
      if (hasRole([1, 6])) {
        headers.push("State");
      }
      if (hasRole([1, 6, 7])) {
        headers.push("Region");
      }
      if (hasRole([1, 6, 7, 2])) {
        headers.push("Chapter");
      }
      headers.push("Member");

      if (reportType === "top_10_points_members") {
        if (
          !data.top10PointsUsersList ||
          data.top10PointsUsersList.length === 0
        ) {
          toast.error("No data available to export");
          return;
        }
        // Define table headers and data
        headers.push("Points");
        pdfData = data.top10PointsUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.points);
          return pData;
        });
        fileName = `Top10Points_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Points`;
      } else if (reportType === "top_10_business_given_members") {
        if (
          !data.top10BusinessUsersList ||
          data.top10BusinessUsersList.length === 0
        ) {
          toast.error("No data available to export");
          return;
        }
        // Define table headers and data
        headers.push("Business Value");
        pdfData = data.top10BusinessUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(
            parseFloat(data.business_value_without_format).toLocaleString(
              "en-IN",
            ),
          );
          return pData;
        });
        fileName = `Top10Business_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Business Value`;
      } else if (reportType === "top_10_referral_given_members") {
        if (
          !data.top10ReferralsGivenUsersList ||
          data.top10ReferralsGivenUsersList.length === 0
        ) {
          toast.error("No data available to export");
          return;
        }
        // Define table headers and data
        headers.push("RFLs Count");
        pdfData = data.top10ReferralsGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.referrals_count);
          return pData;
        });
        fileName = `Top10Referrals_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Referrals Given Count`;
      } else if (reportType === "top_10_visitors_members") {
        if (
          !data.top10VisitorsGivenUsersList ||
          data.top10VisitorsGivenUsersList.length === 0
        ) {
          toast.error("No data available to export");
          return;
        }
        // Define table headers and data
        headers.push("Visitors Count");
        pdfData = data.top10VisitorsGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.visitors_count);
          return pData;
        });
        fileName = `Top10Visitors_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by Visitors Given Count`;
      } else if (reportType === "top_10_121_members") {
        if (
          !data.top10121sGivenUsersList ||
          data.top10121sGivenUsersList.length === 0
        ) {
          toast.error("No data available to export");
          return;
        }
        // Define table headers and data
        headers.push("121s Count");
        pdfData = data.top10121sGivenUsersList.map((data) => {
          let pData = [data.sno];
          if (hasRole([1])) {
            pData.push(data.country_name);
          }
          if (hasRole([1, 6])) {
            pData.push(data.state_name);
          }
          if (hasRole([1, 6, 7])) {
            pData.push(data.region_name);
          }
          if (hasRole([1, 6, 7, 2])) {
            pData.push(data.chapter_name);
          }
          pData.push(data.name);
          pData.push(data.one2one_count);
          return pData;
        });
        fileName = `Top10121s_${currentDate}.pdf`;
        pdfTitle = `Top 10 Members by 121s Given Count`;
      }

      //pdf title starts
      const textWidth =
        (doc.getStringUnitWidth(pdfTitle) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.width - textWidth) / 2;
      doc.text(pdfTitle, textOffset, 10); // Centered title at the top
      //pdf title ends

      // Add the table to the document
      autoTable(doc, {
        head: [headers],
        body: pdfData,
        margin: { top: 20, right: 20, bottom: 20, left: 20 },
        startY: 20,
        headStyles: { fillColor: [1, 147, 66], textColor: [255, 255, 255] },
        styles: { lineWidth: 0.1 },
      });
      // Save the PDF
      doc.save(fileName);
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      toast.error(error.message);
    } finally {
      setPdfLoading(false);
    }
  };

  //month wise chart data - business achieved
  const [chartDataSet, setChartDataSet] = useState([]);
  const valueFormatter = (value) => `₹${value} `;
  const chartSetting = {
    series: [
      {
        dataKey: "amount",
        label: "Business",
        valueFormatter,
        color: "#019342",
        area: true,
      },
    ],
    height: 300,
    sx: {
      [`& .${axisClasses.directionY}`]: {
        transform: "translateX(-10px)",
      },
    },
  };
  //end

  //month wise chart data - 121s, rfls, visitors
  const [chartDataSet1, setChartDataSet1] = useState([]);

  const chartSetting1 = {
    yAxis: [
      {
        label: "",
        width: 60,
      },
    ],
    height: 300,
  };
  //end

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    refFlatpickr.current.flatpickr.setDate([]);
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    });
  };

  useEffect(() => {
    setOvalLoading(true);
    setLoading(true);
    axios
      .get(DASHBOARD, {
        params: {
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data);
          setChartDataSet(response.data.data.monthWiseBusinessList);
          setChartDataSet1(response.data.data.monthWise121RFlVisitorList);
        }
      })
      .finally(() => {
        setOvalLoading(false);
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filter]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  return (
    <div className="content-wrapper">
      <div className="flex-grow-1">
        <div className="container-fluid dp-wrapper px-0">
          {/* Sticky filter bar - fixed below navbar */}
          <div
            id="dashboard-filter-bar"
            ref={filterBarRef}
            style={{
              position: "fixed",
              top: "75px",
              right: "0",
              zIndex: 99,
              background: "#f5f5f9",
              // borderBottom: "1px solid #e9ecef",
              padding: "24px",
              // boxShadow: "0 2px 6px rgba(219, 161, 161, 0.06)",
            }}
          >
            <div className="col-md-12 px-0">
              <div className="filter_wrapper">
                {hasRole([1]) && (
                  <div>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="country_id"
                      isClearable
                      options={countryOptions}
                      placeholder="All Countries"
                      onChange={(selected) => {
                        handleStateClear();
                        setFilter({
                          ...filter,
                          country_id: selected?.value,
                          state_id: null,
                          region_id: null,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                )}

                {hasRole([1, 6]) && (
                  <div>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectStateRef}
                      name="state_id"
                      isClearable
                      options={stateOptions}
                      placeholder="All States"
                      onChange={(selected) => {
                        handleRegionClear();
                        setFilter({
                          ...filter,
                          state_id: selected?.value,
                          region_id: null,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                )}

                {hasRole([1, 6, 7]) && (
                  <div>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectRegionRef}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      placeholder="All Regions"
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                )}

                {hasRole([1, 6, 7, 2]) && (
                  <div>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      placeholder="All Chapters"
                      onChange={(selected) =>
                        setFilter({ ...filter, chapter_id: selected?.value })
                      }
                    />
                  </div>
                )}

                <div>
                  <div className="dash_dp datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                to_date: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          },
                        }}
                        placeholder="Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Spacer — height mirrors the fixed filter bar dynamically */}
          <div style={{ height: `${filterBarHeight}px` }} />
        </div>
      </div>

      <div className="flex-grow-1">
        {/* dashboard counts */}

        <div className="row mb-4">
          <div className="col-xl-12">
            <div className="dash-modern-counts-wrapper">
              <div className="row row-cols-xxl-4 row-cols-lg-3 row-cols-md-2 row-cols-1 g-3">
                {hasRole([1]) && hasPermission("countries-list") && (
                  <div className="col">
                    <Link to={"/countries"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f35d2d" }}
                      >
                        <img src={Country} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Countries</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.countryCount || 0
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1, 6]) && hasPermission("states-list") && (
                  <div className="col">
                    <Link to={"/states"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#1ec074" }}
                      >
                        <img src={State} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">States</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.stateCount || 0
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1, 6, 7]) && hasPermission("regions-list") && (
                  <div className="col">
                    <Link to={"/regions"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#4680ff" }}
                      >
                        <img src={Region} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Regions</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.regionCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1, 6, 7, 2]) && hasPermission("chapters-list") && (
                  <div className="col">
                    <Link to={"/chapters"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#109b9f" }}
                      >
                        <img src={Glasschap} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Chapters</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.chapterCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("members-list") && (
                  <div className="col">
                    <Link to={"/users"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f7b84b" }}
                      >
                        <img src={Glassusers} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Members</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.usersCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1]) && hasPermission("country-admins-list") && (
                  <div className="col">
                    <Link
                      to={"/country-admin-users"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f35d2d" }}
                      >
                        <img src={Admin} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">
                          Country Admins
                        </div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.countryAdminUsersCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1, 6]) && hasPermission("state-admins-list") && (
                  <div className="col">
                    <Link
                      to={"/state-admin-users"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#1ec074" }}
                      >
                        <img src={Admin} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">
                          State Admins
                        </div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.stateAdminUsersCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1, 6, 7]) && hasPermission("region-admins-list") && (
                  <div className="col">
                    <Link
                      to={"/region-admin-users"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#4680ff" }}
                      >
                        <img src={Admin} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">
                          Region Admins
                        </div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.regionAdminUsersCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasRole([1, 6, 7, 2]) &&
                  hasPermission("chapter-admins-list") && (
                    <div className="col">
                      <Link
                        to={"/chapter-admin-users"}
                        className="dash-modern-stat-card"
                      >
                        <div
                          className="dash-modern-stat-icon"
                          style={{ backgroundColor: "#109b9f" }}
                        >
                          <img src={Admin} alt="icon" />
                        </div>
                        <div className="dash-modern-stat-info">
                          <div className="dash-modern-stat-title">
                            Chapter Admins
                          </div>
                          <div className="dash-modern-stat-value">
                            {ovalLoading ? (
                              <OvalLoader color="#ffffff" />
                            ) : (
                              data.chapterAdminUsersCount
                            )}
                          </div>
                        </div>
                        <div className="dash-modern-stat-chart-icon">
                          <FaChartSimple color="#019342" />
                        </div>
                      </Link>
                    </div>
                  )}

                {hasPermission("dashboard-121s-data-view") && (
                  <div className="col">
                    <Link to={"/one-to-one"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f7b84b" }}
                      >
                        <img src={One2one} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">121s</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.one2oneCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-rfls-data-view") && (
                  <div className="col">
                    <Link to={"/referrals"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f35d2d" }}
                      >
                        <img src={Referals} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">RFLs</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.referralsCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-tyns-data-view") && (
                  <div className="col">
                    <Link to={"/tyfcbs"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#1ec074" }}
                      >
                        <img src={Contribution} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Biz</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.tynsCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-visitors-data-view") && (
                  <div className="col">
                    <Link
                      to={"/visitors/general"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#4680ff" }}
                      >
                        <img src={Glassusers} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Visitors</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.generalVisitorsCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-visitors-data-view") && (
                  <div className="col">
                    <Link
                      to={"/visitors/chief-guest"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#109b9f" }}
                      >
                        <img src={Guest} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">
                          Chief Guest
                        </div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.chiefGuestCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-visitors-data-view") && (
                  <div className="col">
                    <Link
                      to={"/visitors/power-date"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f7b84b" }}
                      >
                        <img src={Powerdate} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Power Date</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.powerDateCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-visitors-data-view") && (
                  <div className="col">
                    <Link
                      to={"/visitors/inductions"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f35d2d" }}
                      >
                        <img src={Inductions} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Inductions</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.inductionsCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("dashboard-visitors-data-view") && (
                  <div className="col">
                    <Link
                      to={"/visitors/consumers"}
                      className="dash-modern-stat-card"
                    >
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#f35d2d" }}
                      >
                        <img src={Consumers} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Consumers</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.consumersCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}

                {hasPermission("events-list") && (
                  <div className="col">
                    <Link to={"/events"} className="dash-modern-stat-card">
                      <div
                        className="dash-modern-stat-icon"
                        style={{ backgroundColor: "#1ec074" }}
                      >
                        <img src={Events} alt="icon" />
                      </div>
                      <div className="dash-modern-stat-info">
                        <div className="dash-modern-stat-title">Events</div>
                        <div className="dash-modern-stat-value">
                          {ovalLoading ? (
                            <OvalLoader color="#ffffff" />
                          ) : (
                            data.eventsCount
                          )}
                        </div>
                      </div>
                      <div className="dash-modern-stat-chart-icon">
                        <FaChartSimple color="#019342" />
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {hasPermission("dashboard-tyns-data-view") && (
          <div className="row mb-4">
            <div className="col-lg-12 d-flex align-items-stretch">
              <div className="card w-100 bg-primary-subtle overflow-hidden shadow-none overall-card">
                <div
                  className="card-body position-relative"
                  style={{ "--swiper-navigation-size": "30px" }}
                >
                  <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    <SwiperSlide>
                      <div className="row d-flex align-items-center">
                        <div className="col-sm-4 p-40">
                          <div className="overall-wrapper">
                            <div className="d-flex align-items-center mb-7">
                              <div className="rounded-circle overflow-hidden me-2">
                                <img
                                  src={user1}
                                  alt="img"
                                  width="40"
                                  height="40"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              <div className="border-end pe-4 border-muted border-opacity-10">
                                <h5 className="fw-semibold mb-0 fs-5 d-flex align-items-center">
                                  Overall Business Achieved
                                </h5>
                                <h3 className="mb-1 fw-semibold fs-8 d-flex align-content-center">
                                  {ovalLoading ? (
                                    <OvalLoader color="#CC337F" />
                                  ) : (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip className="tyntooltip">
                                          {data.overallTynsAmountText || ""}
                                        </Tooltip>
                                      }
                                    >
                                      <span style={{ cursor: "pointer" }}>
                                        {data.overallTynsAmount}
                                      </span>
                                    </OverlayTrigger>
                                  )}

                                  <i className="ti ti-arrow-up-right fs-5 lh-base text-success"></i>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-8 pl-30">
                          <div className="d-flex h-100 align-items-center justify-content-center">
                            {ovalLoading ? (
                              <OvalLoader color="#CC337F" />
                            ) : (
                              <LineChart
                                // borderRadius={4}
                                dataset={chartDataSet}
                                // grid={{ horizontal: true }}
                                xAxis={[
                                  {
                                    scaleType: "point",
                                    dataKey: "month",
                                  },
                                ]}
                                {...chartSetting}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="row d-flex align-items-center">
                        <div className="col-sm-12 pl-30">
                          <div className="d-flex h-100 align-items-center justify-content-center">
                            {ovalLoading ? (
                              <OvalLoader color="#CC337F" />
                            ) : (
                              <BarChart
                                dataset={chartDataSet1}
                                xAxis={[
                                  { dataKey: "month", scaleType: "band" },
                                ]}
                                series={[
                                  {
                                    dataKey: "tyfcb",
                                    label: "Biz",
                                    color: "#FF9800",
                                  },
                                  {
                                    dataKey: "one_to_one",
                                    label: "121s",
                                    color: "#1976d2",
                                  },
                                  {
                                    dataKey: "referral",
                                    label: "RFLs",
                                    color: "#388e3c",
                                  },
                                  {
                                    dataKey: "visitor",
                                    label: "Visitors",
                                    color: "#f57c00",
                                  },
                                ]}
                                {...chartSetting1}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        )}

        {(hasPermission("dashboard-tyns-data-view") ||
          hasPermission("dashboard-121s-data-view") ||
          hasPermission("dashboard-rfls-data-view") ||
          hasPermission("dashboard-visitors-data-view")) && (
          <div className="row">
            <div className="col-lg-12">
              <div className="card mb-3 custom-card">
                <div className="card-header border-bottom">
                  <h5>
                    This Week Top Achievers ({data.week_start_date} -{" "}
                    {data.week_end_date})
                  </h5>

                  {/* <Select
                  name="dateFilterId"
                  isClearable
                  options={dateFilterOptions}
                  placeholder="Overall"
                  onChange={(selected) => {
                    // setFilter({
                    //   ...filter,
                    //   dateFilterId: selected?.value,
                    // });
                  }}
                /> */}
                </div>

                <div className="card-body">
                  <div className="row">
                    {hasPermission("dashboard-tyns-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Biz Given ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekOverallTyfcb
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={Smile} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList.tyfcbsList
                                ?.length > 0 ? (
                              data.thisWeekTop3AchieversList.tyfcbsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.from_user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.tyfcb_amount}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-121s-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                121s ({" "}
                                {data.thisWeekTop3AchieversList?.thisWeek121s} )
                              </h3>
                            </div>
                            <div>
                              <img src={OnetoOneWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList.onetooneList
                                ?.length > 0 ? (
                              data.thisWeekTop3AchieversList.onetooneList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.from_user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.from_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.from_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.from_user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.one2one_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-rfls-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                {" "}
                                RFLs ({" "}
                                {data.thisWeekTop3AchieversList?.thisWeekRfls} )
                              </h3>
                            </div>
                            <div>
                              <img src={RflWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList.referralsList
                                ?.length > 0 ? (
                              data.thisWeekTop3AchieversList.referralsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.from_user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                      {ovalLoading ? (
                        <OvalLoader color="#019342" />
                      ) :
                        data.thisWeekTop3AchieversList.referralsList?.length > 0 ? (
                          data.thisWeekTop3AchieversList.referralsList?.map((user, i) => (
                            <div className="profile-wrapper mb-2">
                              <div className="profile-img-group">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>{user.region_name} - {user.chapter_name}</Tooltip>}
                                >
                                  {/* <div className="profile-img1">
                                    <img src={user.from_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.from_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.from_user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.referrals_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Visitors (
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekVisitors
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={VisitorsWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList
                                .generalVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.generalVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Chief Guest ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekChiefGuests
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={chiefGuestWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList
                                .cheifGuestVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.cheifGuestVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Power Date ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekPowerDates
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={calendarWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList
                                .powerDateVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.powerDateVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Inductions ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekInductions
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={calendarWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList
                                .inductionsVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.inductionsVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {hasPermission("dashboard-visitors-data-view") && (
                      <div className="col-lg-4 col-md-4 p-2">
                        <div className="profile-card">
                          <div className="profile-title">
                            <div className="title">
                              <h3>
                                Consumers ({" "}
                                {
                                  data.thisWeekTop3AchieversList
                                    ?.thisWeekConsumers
                                }{" "}
                                )
                              </h3>
                            </div>
                            <div>
                              <img src={calendarWhite} alt="icon" />
                            </div>
                          </div>
                          <div className="profile-content">
                            {ovalLoading ? (
                              <OvalLoader color="#019342" />
                            ) : data.thisWeekTop3AchieversList
                                .consumersVisitorsList?.length > 0 ? (
                              data.thisWeekTop3AchieversList.consumersVisitorsList?.map(
                                (user, i) => (
                                  <div className="profile-wrapper mb-2">
                                    <div className="profile-img-group">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {user.sno}. {user.user_name} ({" "}
                                            {user.user_company_name} ) -{" "}
                                            {user.country_name} -{" "}
                                            {user.state_name} -{" "}
                                            {user.region_name} -{" "}
                                            {user.chapter_name}
                                          </Tooltip>
                                        }
                                      >
                                        {/* <div className="profile-img1">
                                    <img src={user.user_profile_image} title="Profile Name" />
                                  </div> */}
                                        <div>
                                          <span className="table_img pr-2">
                                            <img
                                              src={user?.user_profile_image}
                                              alt="icon"
                                            />
                                          </span>
                                          {user?.user_name}
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                    <div className="more-icon">
                                      <div className="count">
                                        <span>{user.visitors_count}</span>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <NoUserFound />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row dash-table">
        {hasPermission("dashboard-monthly-fees-pending-list-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Monthly Meeting Fee Payment Pending List</h5>
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      <th>Name</th>
                      <th>Pending Month</th>
                      <th>Pending Fees</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="8" />
                    ) : data.monthlyFeesPendingList?.length > 0 ? (
                      data.monthlyFeesPendingList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.pending_months}</td>
                          <td>{users?.pending_fees}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="8" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-weekly-meeting-not-attended-list-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Weekly Attendance Absentees List</h5>
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>

                      <th>Name</th>
                      <th>Absent Meetings</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.weeklyMeetingPendingList?.length > 0 ? (
                      data.weeklyMeetingPendingList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>

                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.pending_weeks}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row dash-table">
        {hasPermission("dashboard-points-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Performing Members</h5>
                {hasPermission("dashboard-points-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#019342",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_points_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>

                      <th>Name</th>
                      <th>Points</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10PointsUsersList?.length > 0 ? (
                      data.top10PointsUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>

                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.points}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-tyns-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Business Given Members</h5>
                {hasPermission("dashboard-tyns-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#019342",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_business_given_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="text-nowrap table-responsive">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      <th>Name</th>
                      <th>Business Value</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10BusinessUsersList?.length > 0 ? (
                      data.top10BusinessUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.business_value}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.business_value}</td>
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row dash-table">
        {hasPermission("dashboard-rfls-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 RFLs Given Members</h5>
                {hasPermission("dashboard-rfls-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#019342",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_referral_given_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      <th>Name</th>
                      <th>RFLs Count</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10ReferralsGivenUsersList?.length > 0 ? (
                      data.top10ReferralsGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>

                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.referrals_count}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-visitors-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 Visitors Given Members</h5>
                {hasPermission("dashboard-visitors-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#019342",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_visitors_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>

                      <th>Name</th>
                      <th>Visitors Count</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10VisitorsGivenUsersList?.length > 0 ? (
                      data.top10VisitorsGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>

                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.visitors_count}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {hasPermission("dashboard-121s-data-view") && (
          <div className="col-lg-6 mb-3">
            <div className="card icard">
              <div className="card-header">
                <h5>Top 10 121s By Members</h5>
                {hasPermission("dashboard-121s-data-view-export") && (
                  <span title="Download PDF">
                    <i
                      className={`bx bxs-file-pdf ${pdfLoading ? "bx-spin" : ""}`}
                      style={{
                        color: "#019342",
                        fontSize: "25px",
                        cursor: pdfLoading ? "not-allowed" : "pointer",
                        opacity: pdfLoading ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (!pdfLoading)
                          handleDownloadPDF("top_10_121_members");
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className="table-responsive text-nowrap">
                <table className="table table-striped itable">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>

                      <th>Name</th>
                      <th>121s Count</th>
                      {hasRole([1]) && <th>Country</th>}
                      {hasRole([1, 6]) && <th>State</th>}
                      {hasRole([1, 6, 7]) && <th>Region</th>}
                      {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                    </tr>
                  </thead>
                  <tbody className="table-border-bottom-0">
                    {loading ? (
                      <Loader loading={loading} colspan="7" />
                    ) : data.top10121sGivenUsersList?.length > 0 ? (
                      data.top10121sGivenUsersList?.map((users, i) => (
                        <tr key={i}>
                          <td>{users?.sno}</td>

                          <td>
                            <span className="table_img pr-2">
                              <img src={users?.profile_image} alt="icon" />
                            </span>
                            {users?.name}
                          </td>
                          <td>{users?.one2one_count}</td>
                          {hasRole([1]) && <td>{users?.country_name}</td>}
                          {hasRole([1, 6]) && <td>{users?.state_name}</td>}
                          {hasRole([1, 6, 7]) && <td>{users?.region_name}</td>}
                          {hasRole([1, 6, 7, 2]) && (
                            <td>{users?.chapter_name}</td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <NoDataFound colspan="7" message="No Data Found" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="content-backdrop fade"></div>
    </div>
  );
};

export default Dashboard;
